import {
  ISubscriptions,
  SubscriptionsSchemaFields,
  SubscriptionsSchemaFieldWithName,
} from 'src/types';

export const hasSelectionChanged = (
  selectedThemaSubjects: SubscriptionsSchemaFieldWithName[],
  savedThemaSubjects: SubscriptionsSchemaFieldWithName[]
): boolean =>
  JSON.stringify(selectedThemaSubjects) !== JSON.stringify(savedThemaSubjects);

export const extractThemaSubjectsFromSchema = (
  subscriptionsSchemaFields: SubscriptionsSchemaFields
): SubscriptionsSchemaFieldWithName[] => {
  const themaKeys = Object.keys(subscriptionsSchemaFields).filter((key) =>
    key.startsWith('thema.')
  );
  return themaKeys.map((key) => {
    return { name: key, ...subscriptionsSchemaFields[key] };
  });
};

export const constructSubscriptionsObject = (
  allSubjects: SubscriptionsSchemaFieldWithName[],
  selectedSubjects: SubscriptionsSchemaFieldWithName[]
): ISubscriptions => {
  return allSubjects.reduce((acc, item) => {
    const isSubscribed = !!selectedSubjects?.find(
      (selected) => selected.name === item.name
    );
    acc[item.name] = { email: { isSubscribed } };
    return acc;
  }, {});
};
